import { useState } from 'react';
import { rankingData, rankingTabs } from '@/mocks/home';

export default function RankingSection() {
  const [active, setActive] = useState<string>(rankingTabs[0]);
  const list = rankingData[active];

  return (
    <section id="ranking" className="border-y border-background-200 bg-foreground-950">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-300">
              <i className="ri-fire-line" />
              Trending
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">热门榜单</h2>
            <p className="mt-2 text-sm text-background-300">
              基于本周真实下载与收藏数据统计，热度按实时加权排序，每日更新。
            </p>
          </div>

          <div className="flex items-center gap-1 rounded-full bg-background-50/10 p-1">
            {rankingTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-medium transition-colors ${
                  active === tab
                    ? 'bg-primary-500 text-background-50'
                    : 'text-background-200 hover:text-background-50'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-x-8 gap-y-1 lg:grid-cols-2">
          {list.map((item, idx) => (
            <li
              key={item.name}
              className="flex items-center gap-4 border-b border-background-50/10 py-3.5 last:border-b-0"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  idx < 3 ? 'bg-accent-500 text-foreground-950' : 'bg-background-50/10 text-background-200'
                }`}
              >
                {idx + 1}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="truncate text-sm font-medium text-background-50">{item.name}</p>
                  <span className="hidden shrink-0 rounded-full bg-background-50/10 px-2 py-0.5 text-[10px] text-background-200 sm:inline">
                    {item.category}
                  </span>
                </div>
                <div className="mt-2 flex items-center gap-3">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-50/10">
                    <div className="h-full rounded-full bg-primary-500" style={{ width: `${item.heat}%` }} />
                  </div>
                  <span className="w-20 shrink-0 text-right text-[11px] text-background-300">{item.metric}</span>
                </div>
              </div>

              <span className="flex shrink-0 items-center gap-0.5 text-[11px] font-medium text-accent-300">
                <i className="ri-arrow-up-line" />
                {item.delta}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}